import Loading from '../../Common/Loading';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';
import { TopMortalityCids } from './TopMortalityCids';
import { ByCidChapter } from './ByCidChapter';
import { TopDiagnosis } from './TopDiagnosis';
import { MortalityEvolution } from './MortalityEvolution';
import { TopMortalityCidsTable } from './TopMortalityCidsTable';
import { ByCidChapterTable } from './ByCidChapterTable';
import { TopDiagnosisTable } from './TopDiagnosisTable';
import '../Common/Styles/Ciha.css'

export const Charts = () => {
    const { isLoading } = useEpidemiologyChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-ciha-dashboards">
                <MortalityEvolution />
            </div>
            <div className="charts-side-by-side-ciha-dashboards">
                <TopDiagnosis />
                <TopDiagnosisTable />
            </div>
            <div className="charts-side-by-side-ciha-dashboards mt-2 mb-2">
                <TopMortalityCids />
                <TopMortalityCidsTable />
            </div>
            <div className="charts-side-by-side-ciha-dashboards">
                <ByCidChapter />
                <ByCidChapterTable />
            </div>

        </>
    );
};
